import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "rich-editor border border-gray-300 rounded-lg overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-wrap gap-0.5 p-2 bg-gray-50 border-b border-gray-200"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Toolbar "),
    ($setup.editor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = $event => ($setup.editor.chain().focus().toggleBold().run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive('bold'))),
            title: "Bold"
          }, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("strong", null, "B", -1 /* CACHED */)
          ]))], 2 /* CLASS */),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = $event => ($setup.editor.chain().focus().toggleItalic().run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive('italic'))),
            title: "Italic"
          }, [...(_cache[21] || (_cache[21] = [
            _createElementVNode("em", null, "I", -1 /* CACHED */)
          ]))], 2 /* CLASS */),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = $event => ($setup.editor.chain().focus().toggleUnderline().run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive('underline'))),
            title: "Underline"
          }, [...(_cache[22] || (_cache[22] = [
            _createElementVNode("span", { class: "underline" }, "U", -1 /* CACHED */)
          ]))], 2 /* CLASS */),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = $event => ($setup.editor.chain().focus().toggleStrike().run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive('strike'))),
            title: "Strikethrough"
          }, [...(_cache[23] || (_cache[23] = [
            _createElementVNode("span", { class: "line-through" }, "S", -1 /* CACHED */)
          ]))], 2 /* CLASS */),
          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "w-px h-6 bg-gray-300 mx-1" }, null, -1 /* CACHED */)),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[4] || (_cache[4] = $event => ($setup.editor.chain().focus().toggleHeading({ level: 2 }).run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive('heading', { level: 2 }))),
            title: "Heading"
          }, " H2 ", 2 /* CLASS */),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[5] || (_cache[5] = $event => ($setup.editor.chain().focus().toggleHeading({ level: 3 }).run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive('heading', { level: 3 }))),
            title: "Subheading"
          }, " H3 ", 2 /* CLASS */),
          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "w-px h-6 bg-gray-300 mx-1" }, null, -1 /* CACHED */)),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[6] || (_cache[6] = $event => ($setup.editor.chain().focus().toggleBulletList().run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive('bulletList'))),
            title: "Bullet list"
          }, " • ", 2 /* CLASS */),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[7] || (_cache[7] = $event => ($setup.editor.chain().focus().toggleOrderedList().run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive('orderedList'))),
            title: "Numbered list"
          }, " 1. ", 2 /* CLASS */),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[8] || (_cache[8] = $event => ($setup.editor.chain().focus().toggleBlockquote().run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive('blockquote'))),
            title: "Quote"
          }, " “ ", 2 /* CLASS */),
          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "w-px h-6 bg-gray-300 mx-1" }, null, -1 /* CACHED */)),
          _createElementVNode("button", {
            type: "button",
            onClick: $setup.setLink,
            class: _normalizeClass($setup.btnClass($setup.editor.isActive('link'))),
            title: "Link"
          }, " 🔗 ", 2 /* CLASS */),
          _createElementVNode("button", {
            type: "button",
            onClick: $setup.addImage,
            disabled: $setup.uploading,
            class: "px-2 py-1 text-xs rounded hover:bg-gray-200 text-gray-700 cursor-pointer",
            title: "Upload image"
          }, _toDisplayString($setup.uploading ? '...' : '📷'), 9 /* TEXT, PROPS */, _hoisted_3),
          _createElementVNode("button", {
            type: "button",
            onClick: $setup.addImageByUrl,
            class: "px-2 py-1 text-xs rounded hover:bg-gray-200 text-gray-700 cursor-pointer",
            title: "Image URL"
          }, " 🌐 "),
          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "w-px h-6 bg-gray-300 mx-1" }, null, -1 /* CACHED */)),
          _createCommentVNode(" Image float controls "),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[9] || (_cache[9] = $event => ($setup.setImageFloat('left'))),
            class: _normalizeClass($setup.btnClass($setup.isImageFloat('left'))),
            title: $setup.t('news.float_wrap_left')
          }, " ◀☰ ", 10 /* CLASS, PROPS */, _hoisted_4),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[10] || (_cache[10] = $event => ($setup.setImageFloat('none'))),
            class: _normalizeClass($setup.btnClass($setup.isImageFloat('none'))),
            title: $setup.t('news.float_wrap_none')
          }, " ■ ", 10 /* CLASS, PROPS */, _hoisted_5),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[11] || (_cache[11] = $event => ($setup.setImageFloat('right'))),
            class: _normalizeClass($setup.btnClass($setup.isImageFloat('right'))),
            title: $setup.t('news.float_wrap_right')
          }, " ☰▶ ", 10 /* CLASS, PROPS */, _hoisted_6),
          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "w-px h-6 bg-gray-300 mx-1" }, null, -1 /* CACHED */)),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[12] || (_cache[12] = $event => ($setup.editor.chain().focus().setTextAlign('left').run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive({ textAlign: 'left' }))),
            title: "Align left"
          }, " ⇤ ", 2 /* CLASS */),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[13] || (_cache[13] = $event => ($setup.editor.chain().focus().setTextAlign('center').run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive({ textAlign: 'center' }))),
            title: "Align center"
          }, " ↔ ", 2 /* CLASS */),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[14] || (_cache[14] = $event => ($setup.editor.chain().focus().setTextAlign('right').run())),
            class: _normalizeClass($setup.btnClass($setup.editor.isActive({ textAlign: 'right' }))),
            title: "Align right"
          }, " ⇥ ", 2 /* CLASS */),
          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "w-px h-6 bg-gray-300 mx-1" }, null, -1 /* CACHED */)),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[15] || (_cache[15] = $event => ($setup.editor.chain().focus().setHorizontalRule().run())),
            class: "px-2 py-1 text-xs rounded hover:bg-gray-200 text-gray-700 cursor-pointer",
            title: "Horizontal rule"
          }, " — "),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[16] || (_cache[16] = $event => ($setup.editor.chain().focus().undo().run())),
            class: "px-2 py-1 text-xs rounded hover:bg-gray-200 text-gray-700 cursor-pointer",
            title: "Undo"
          }, " ↩ "),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[17] || (_cache[17] = $event => ($setup.editor.chain().focus().redo().run())),
            class: "px-2 py-1 text-xs rounded hover:bg-gray-200 text-gray-700 cursor-pointer",
            title: "Redo"
          }, " ↪ "),
          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "w-px h-6 bg-gray-300 mx-1" }, null, -1 /* CACHED */)),
          _createElementVNode("button", {
            type: "button",
            onClick: $setup.toggleHtml,
            class: _normalizeClass($setup.btnClass($setup.htmlMode)),
            title: "HTML"
          }, " </> ", 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Visual editor "),
    (!$setup.htmlMode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "p-3 cursor-text",
          onClick: _cache[18] || (_cache[18] = $event => ($setup.editor?.commands.focus())),
          style: {"min-height":"200px"}
        }, [
          _createVNode($setup["EditorContent"], {
            editor: $setup.editor,
            class: "prose prose-sm max-w-none focus:outline-none"
          }, null, 8 /* PROPS */, ["editor"])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createCommentVNode(" HTML source editor "),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($setup.htmlSource) = $event)),
            onInput: $setup.onHtmlInput,
            class: "w-full p-3 text-sm font-mono text-gray-700 focus:outline-none",
            style: {"min-height":"200px","resize":"vertical"}
          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vModelText, $setup.htmlSource]
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
    _createCommentVNode(" Hidden file input "),
    _createElementVNode("input", {
      ref: "fileInput",
      type: "file",
      accept: "image/*",
      class: "hidden",
      onChange: $setup.onFileSelected
    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
  ]))
}